import { smoothPath } from "../features/home/metrics";

/**
 * Sparkline dos indicadores do Zênite (`renderKpiSparks`): 96×34, curva suave
 * com preenchimento a 13%, ponto no último valor e animação escalonada por
 * cartão. Decorativa: o número e a variação ao lado carregam a informação.
 */
export function Spark({
  points,
  color,
  label,
  index = 0,
}: {
  points: readonly number[];
  color: string;
  label: string;
  /** Posição do cartão na fileira; escalona os atrasos como no protótipo. */
  index?: number;
}) {
  const width = 96;
  const height = 34;
  const values = points.length ? points : [0];
  const max = Math.max(...values);
  const min = Math.min(...values);
  const span = max - min || 1;
  const coords: Array<[number, number]> = values.map((value, position) => [
    3 + ((width - 6) * position) / Math.max(1, values.length - 1),
    height - 6 - (height - 14) * ((value - min) / span),
  ]);
  if (coords.length === 1) coords.push([width - 3, coords[0][1]]);
  const line = smoothPath(coords);
  const last = coords[coords.length - 1];
  const fill = `${line} L${last[0]},${height} L${coords[0][0]},${height} Z`;
  return (
    <svg className="spark" viewBox={`0 0 ${width} ${height}`} role="img" aria-label={label}>
      <path className="sp-fill" d={fill} fill={color} opacity=".13" style={{ animationDelay: `${0.3 + index * 0.08}s` }} />
      <path
        className="sp-line"
        pathLength={1}
        d={line}
        fill="none"
        stroke={color}
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ animationDelay: `${index * 0.08}s` }}
      />
      <circle className="sp-dot" cx={last[0]} cy={last[1]} r="2.6" fill={color} style={{ animationDelay: `${0.9 + index * 0.08}s` }} />
    </svg>
  );
}
